import { UserIcon, SearchIcon, ExclamationIcon, UsersIcon, ClipboardCheckIcon } from "@heroicons/react/solid";

export const EMPTY_FIELDS = () => {
    return "Please ensure all required fields have been filled in";
}

export const PASSWORDS_MISMATCH = () => {
    return "Please ensure the two passwords entered are identical";
}

export const INVALID_EMAIL = () => {
    return "Please enter a valid email address";
}

export const INVALID_ASSESSMENT = () => {
    return "Please select an assessment";
}

export const BUTTON_VARIANT_TYPES = {
    GRAY: "gray-button",
    GREEN: "green-button",
    AMBER: "amber-button",
    WHITE: "white-button",
    UNCOLOURED: "uncoloured-button"
};

export const DOCUMENT_TYPES_STYLING = {
    PDF: "pdf",
    WORD: "word",
};

export const AUTH_TYPE = {
    APP: "app",
    ASSESSMENT: "assessment"
}

export const AUTH_PROVIDERS = {
    XECURIFY: "xecurify"
}

export const BASIC_ANIMATION_VARIANTS = {
    active: { opacity: 1 },
    inactive: { opacity: 0 },
}

export const PERMISSIONS = {
    ACCESS_PSYCHPRESS_PORTAL: "CP-A-PPP",
    UNLOCK_USER_ACCOUNTS: "CP-L-UNLKUSR",
    ACCESS_APPLICATIONS: "CP-A-APPS",
    ACCESS_ASSESSMENTS: "CP-A-ASSESS",
    CREATE_USER_GROUPS: "CP-C-USRGRP",
    EDIT_USER_GROUPS: "CP-U-USRGRP",
    DOWNLOAD_REPORTS: "CP-A-DLRPTS",
    ACCESS_HELP_AND_SUPPORT: "CP-A-HLPSPT",
    LAUNCH_APPS: "CP-A-LAUNCH",
    SEARCH: "CP-A-SEARCH",
    SEE_NOTIFICATIONS: "CP-A-NOTIF",
    CREATE_USER_ACCOUNTS: "CP-C-USRACCT",
    ACCESS_SETUP_USER_PAGE: "CP-A-SETUPUSER",
    VIEW_USERS_LIST: "CP-A-USRACCT",
    VIEW_USER_GROUPS_LIST: "CP-A-USRGRP",
    VIEW_REPORTS: "CP-A-REPORTS",
    VIEW_REPORTS_TAB: "CP-V-REPORTSTAB",
    DELETE_USER_ACCOUNTS: "CP-D-USRACCT",
    UPDATE_USER_DETAILS: "CP-U-USRACCT",
    UPLOAD_REPORTS: "CP-U-REPORTS",
    ASSIGN_ASSESSMENTS: "CP-C-ASSESS",
    EDIT_USER_PASSWORDS: "CP-U-USRPWD",
    EDIT_DEFAULT_USER_GROUP: "CP-U-DFTGRP",
    MANAGE_USERS_IN_USER_GROUP: "CP-U-USRUSRGRP",
    DELETE_USER_GROUPS: "CP-D-USRGRP",
    MANAGE_USER_PERMISSIONS: "CP-U-USRPERMS",
    MANAGE_USER_GROUP_PERMISSIONS: "CP-U-GRPPERMS",
    MANAGE_USER_APPLICATIONS: "CP-U-USRAPPS",
    MANAGE_USER_GROUP_APPLICATIONS: "CP-U-GRPAPPS",
    EDIT_OWN_USER_ACCOUNT: "CP-U-SLFACCT",
    EDIT_OWN_PASSWORD: "CP-U-SLFPWD",
    RESET_OWN_PASSWORD: "CP-R-SLFPWD",
    EDIT_HELP_AND_SUPPORT: "CP-U-HLPSPT",
    COPY_TO_USER: "CP-U-COPY",
    VIEW_ORGANISATION_APPS: "CP-A-ORGAPPS",
    EDIT_DOCUMENT_TAGS: "CP-U-DOCTAG",
    EDIT_USER_TAGS: "CP-U-USRTAGS",
    EDIT_USER_GROUP_TAGS: "CP-U-GRPTAGS",
    VIEW_ALL_REPORTS: "CP-A-ALLREPORTS",
    DOWNLOAD_ADDITIONAL_FILES: "CP-A-DLADDFILES",
    EDIT_ORGANISATION_DETAILS: "CP-U-ORG",
    LOGIN: "GBL-A-CANLOGIN"
}

export const NO_ACCESS_TYPES = {
    BLANK: "blank",
    ERRORTEXT: "errortext",
    REDIRECT: "redirect"
}

export const HELP_AND_SUPPORT_CARD_TYPES = {
    PHONE: "PHONE",
    EMAIL: "EMAIL"
}

export const REPORT_CATEGORIES = {
    "Managing self": {
        text: "text-blue-600",
        colour: "blue",
        icon: (
            <div className="bg-blue-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <UserIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Managing tasks": {
        text: "text-fuchsia-600",
        colour: "fuchsia",
        icon: (
            <div className="bg-fuchsia-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <ClipboardCheckIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Managing others": {
        text: "text-violet-600",
        colour: "violet",
        icon: (
            <div className="bg-violet-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <UsersIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Managing risk": {
        text: "text-pink-600",
        colour: "pink",
        icon: (
            <div className="bg-pink-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <ExclamationIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Career Clarity": {
        text: "text-pink-600",
        colour: "pink",
        icon: (
            <div className="bg-pink-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <SearchIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Business Clarity": {
        text: "text-indigo-600",
        colour: "indigo",
        icon: (
            <div className="bg-indigo-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <SearchIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Interests": {
        text: "text-blue-600",
        colour: "blue",
        icon: (
            <div className="bg-blue-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <UserIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Skills": {
        text: "text-fuchsia-600",
        colour: "fuchsia",
        icon: (
            <div className="bg-fuchsia-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <ClipboardCheckIcon className="w-3.5 text-white" />
            </div>
        )
    },
    "Values": {
        text: "text-violet-600",
        colour: "violet",
        icon: (
            <div className="bg-violet-600 rounded-full p-2 w-8 h-8 flex justify-center">
                <UsersIcon className="w-3.5 text-white" />
            </div>
        )
    },
};

export const COLOUR_INTENSITIES = [900, 800, 700, 600, 500, 400, 300, 200]

export const TIME_ENDOFTHEDAY = 'T23:59:59.000Z';

export const WORKFORCE_AUSTRALIA_URL = "https://www.workforceaustralia.gov.au/";